import * as Schema from "effect/Schema";

import { ComputerCommand, ComputerResult } from "./computerUse";

export const NativeHostTrashItemCommand = Schema.Struct({
  kind: Schema.Literal("trash_item"),
  path: Schema.String.check(Schema.isNonEmpty()),
});
export type NativeHostTrashItemCommand = typeof NativeHostTrashItemCommand.Type;

export const NativeHostCommand = Schema.Union([ComputerCommand, NativeHostTrashItemCommand]);
export type NativeHostCommand = typeof NativeHostCommand.Type;

export const NativeHostTrashItemResult = Schema.Struct({
  kind: Schema.Literal("trash_item"),
  path: Schema.String.check(Schema.isNonEmpty()),
});
export type NativeHostTrashItemResult = typeof NativeHostTrashItemResult.Type;

export const NativeHostResult = Schema.Union([ComputerResult, NativeHostTrashItemResult]);
export type NativeHostResult = typeof NativeHostResult.Type;
